import { logger } from '@lusha/client-logger';
import { flow } from 'mobx-state-tree';
import { getCreditsBalance } from '../../../API/accountAssetsApi';
import { delay } from '../../../utils/delay';
import Company from '../../Company';
import Contact from '../../Contact';
import Search from '../../Search';
let latestCreditsRequest = 0;
const Actions = self => ({
    fetchAccountCredits: flow(function* fetchAccountCredits(numberOfCreditsCharged = 0) {
        var _a, _b, _c;
        if (!((_a = envConfig.FEATURES) === null || _a === void 0 ? void 0 : _a.FREE_TRIAL_POPUP))
            return;
        try {
            const reqId = ++latestCreditsRequest;
            const totalCredits = self.totalCredits - numberOfCreditsCharged;
            if (totalCredits >= 0) {
                self.totalCredits = totalCredits;
            }
            // We have a delay here because sometimes BE takes more then 5s to update values fot /balance API
            if (numberOfCreditsCharged) {
                yield delay(8000);
            }
            if (reqId !== latestCreditsRequest)
                return;
            const res = yield getCreditsBalance();
            if (reqId !== latestCreditsRequest)
                return;
            const { shared = [] } = res || {};
            self.accountCreditsTypes = shared;
            shared === null || shared === void 0 ? void 0 : shared.forEach(({ totalUsed, total, type }) => {
                if (type !== 'email' && type !== 'phone') {
                    self.totalCredits = total - totalUsed;
                    self.userPlanTotalCredits = total;
                }
            });
        }
        catch (err) {
            if (err.code !== 401) {
                logger.error('Failed to fetch account balances', {
                    code: err === null || err === void 0 ? void 0 : err.code,
                    httpStatus: err === null || err === void 0 ? void 0 : err.httpStatus,
                    status: err === null || err === void 0 ? void 0 : err.status,
                    message: err === null || err === void 0 ? void 0 : err.message,
                    statusText: err === null || err === void 0 ? void 0 : err.statusText,
                    stack: err === null || err === void 0 ? void 0 : err.stack,
                    accountId: (_b = self.user) === null || _b === void 0 ? void 0 : _b.accountId,
                    userId: (_c = self.user) === null || _c === void 0 ? void 0 : _c.id,
                });
            }
        }
    }),
    init: () => {
        if (self.isInitialized)
            return null;
        self.contextCompany = Company.create({ id: 'contextCompany' });
        self.contextContact = Contact.create({ id: 'contextContact', company: self.contextCompany.id });
        self.prospecting = Search.create({ employee: self.contextContact.id });
        self.searchedCompany = Company.create({ id: 'searchedCompany' });
        self.employee = Contact.create({ id: 'employee', company: self.searchedCompany.id });
        self.search = Search.create({ employee: self.employee.id });
        self.isInitialized = true;
    },
    resetSearchState: () => {
        self.searchedCompany = Company.create({ id: 'searchedCompany' });
        self.employee = Contact.create({ id: 'employee', company: self.searchedCompany.id });
        self.search = Search.create({ employee: self.employee.id });
    },
    addCompany: item => {
        var _a, _b;
        const key = ((_a = item.company_lid) === null || _a === void 0 ? void 0 : _a.toString()) || ((_b = item.companyLid) === null || _b === void 0 ? void 0 : _b.toString()) || item.fqdn;
        const company = Company.create({ id: key });
        company.setCompany(item);
        self.companies.set(key, company);
    },
    clearAllCompanies: () => {
        self.companies.clear();
    },
    setEmptyCompany: id => {
        self.companies.set(id, Company.create({ id }));
    },
});
export default Actions;
